/**
 * IClientData has no "age" property, only dateOfBirth (ISO yyyy-MM-dd). Marketing
 * teasers only ever collect a whole-number age, so the best we can do is derive the
 * birth year and anchor it to a fixed start-of-year placeholder. That keeps the
 * value deterministic and avoids implying we know the actual birth month/day.
 */
export function ageToDateOfBirth(age: string | number | undefined | null): string | undefined {
  if (age === undefined || age === null || age === "") return undefined;

  const ageNumber = Number(age);
  if (!Number.isFinite(ageNumber) || ageNumber <= 0) return undefined;

  const today = new Date();
  const birthYear = today.getFullYear() - Math.trunc(ageNumber);

  return `${birthYear}-01-01`;
}
